import axios from "axios";
import { makeId } from "./default";
import { EventSourcePolyfill } from "event-source-polyfill";

class SseManager {
    constructor(link = '/sse') {

        let uid = window.user ? window.user['id'] : 'anonymous'
        let key = btoa(`${link}_${uid}`)

        if(!SseManager.instances){
            SseManager.instances = {}
        }

        if(SseManager.instances[key]) {
            return SseManager.instances[key]
        }
        
        SseManager.instances[key] = this;

        const storedPid = sessionStorage.getItem('sse_pid_' + key)
        if(!storedPid){
            
            this.pid = `${uid}_${makeId()}`
            sessionStorage.setItem('sse_pid_' + key, this.pid)

        }else {
            this.pid = storedPid
        }
        
        console.log("Create SSE Manager " + this.pid)
        this.link = link
        this.poll = null
        this.register_bar = {}
        this.on_open_bar = {}
        this.connect()
        this.isConnect = false
        this.keepAlive()

        return this;

    }


    isConnected() {
        if (!this.poll) return false
        return this.poll.readyState == 1
    }


    register(object, id, onMesssage = null, onOpen = null) {
        if (onMesssage) {
            if (!this.register_bar[object]) {
                this.register_bar[object] = {}
            }
            this.register_bar[object][id] = onMesssage
        }

        if (onOpen) {
            this.on_open_bar[id] = onOpen
        }
    }

    unRegister(object, id) {
        if (this.register_bar[object]) {
            delete this.register_bar[object][id]
        }
        if (this.on_open_bar[id]) {
            delete this.on_open_bar[id]
        }
    }


    send(data) {
        return axios.request({
            url: this.link,
            method: 'post',
            data: {
                data: data,
                pid: this.pid
            }
        })

            .then(response => {
                response = response['data'];
                if (response['result']) {
                    return response['data']
                }
                error_handle(response)
            })

            .catch((error) => {

                error_handle(error)
            })
    }

    keepAlive() {
        this.keepAliveInterval = setInterval(() => {
            if (this.isConnect) {
                if (!this.isConnected()) {
                    this.disconnect()
                    this.connect()
                }
            }
        }, 5000)
    }

    disconnect() {
        try {
            console.log("Disconnecting SSE")
            this.poll && this.poll.close()
            this.poll = null
            this.isConnect = false
            if(SseManager.instances[this.link]) {
                delete SseManager.instances[this.link]
            }
        } catch (error) {
            console.log(error)
        }
    }


    connect() {

        let token = window.localStorage.getItem('token')
        // const eventSource = new EventSource(this.link + '?pid=' + this.pid);
        const eventSource = new EventSourcePolyfill(this.link + '?pid=' + this.pid, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            heartbeatTimeout: 60000
        });

        eventSource.onmessage = (event) => {
            try {

                if (event.data == 'ping') {
                    this.send('pong')
                    return
                }
                // console.log("SSE Received message from server:", event.data);
                let data = JSON.parse(event.data)
                if (!data) return
                let object = data.object
                if (this.register_bar[object]) {
                    for (let i in this.register_bar[object]) {
                        this.register_bar[object][i](data)
                    }
                }
                if (this.register_bar['all']) {
                    for (let i in this.register_bar['all']) {
                        this.register_bar['all'][i](data)
                    }
                }
            } catch (error) {
                console.log(error)
            }

        };

        eventSource.onopen = (event) => {
            console.log("Polling connection opened");
            this.isConnect = true
            for (let i in this.on_open_bar) {
                this.on_open_bar[i]()
            }
        };

        eventSource.onerror = (error) => {
            console.log("Polling error:", error);
        };

        this.poll = eventSource

    }

}

export default SseManager;